module.exports = __webpack_public_path__ + "img/artificial-intelligence.67f04a49.jpg";